var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 15.414,
    height: 15.467,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6099",
    "data-name": "Group 6099",
    transform: "translate(-416 -2285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(416 2285)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6073",
    "data-name": "Group 6073",
    transform: "translate(426 2295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6044",
    "data-name": "Group 6044",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8531",
    "data-name": "Path 8531",
    d: "M15.195,5.857A7.673,7.673,0,1,0,.832,11.016a1.2,1.2,0,0,1,.1,1.059,6.841,6.841,0,0,0-.221.792L0,15.467a1.905,1.905,0,0,0,.226-.029c1.211-.319,2.42-.643,3.633-.955a.562.562,0,0,1,.36.03A7.688,7.688,0,0,0,15.195,5.857M9.422,13.831a6.285,6.285,0,0,1-4.92-.657.613.613,0,0,0-.528-.069c-.651.188-1.309.35-1.965.521a1.2,1.2,0,0,1-.16.015c.2-.732.393-1.425.567-2.124a.57.57,0,0,0-.06-.4A6.4,6.4,0,0,1,5.547,1.686,6.379,6.379,0,1,1,9.422,13.831",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8532",
    "data-name": "Path 8532",
    d: "M81.7,84.215q-.782-.392-1.576-.761a.33.33,0,0,0-.447.132c-.172.236-.363.458-.547.685a.308.308,0,0,1-.388.107A5.142,5.142,0,0,1,76.109,82.1a.443.443,0,0,1,.028-.369,5.089,5.089,0,0,1,.417-.556.481.481,0,0,0,.058-.53c-.186-.424-.367-.851-.533-1.283-.114-.3-.276-.5-.639-.415l-.016-.075a2.093,2.093,0,0,0-.639.26,2.2,2.2,0,0,0-.533.715,2.388,2.388,0,0,0,.211,2.315A7.958,7.958,0,0,0,79.3,86.076a2.228,2.228,0,0,0,1.98-.348,1.409,1.409,0,0,0,.55-1.313.278.278,0,0,0-.126-.2",
    transform: "translate(-70.221 -74.798)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.62aec7f15d3f4dd8d194336e2c7e2088.svg";
export { ForwardRef as ReactComponent };